import { createFileRoute } from "@tanstack/react-router";
import { ApplyPage } from "../features/apply/apply-page";

export const Route = createFileRoute("/_app/w/$workspace/apply")({ component: ApplyPage });
